<h3>{{ message ? message : ('empty_page_message.default' | translate) }}</h3>
@if (icon) {
  <mat-icon>{{ icon }}</mat-icon>
}
@if (svgIcon) {
  <mat-icon [svgIcon]="svgIcon"></mat-icon>
}
